export const MenuItems = [
    {
        title : "Home",
        url : "/",
        cName : "nav-links",
        icon :  "fa-solid fa-house"
    },
    {
        title : "Tours",
        url : "/tours",
        cName : "nav-links",
        icon :  "fa-solid fa-briefcase"
    },
    {
        title : "About",
        url : "/about",
        cName : "nav-links",
        icon :  "fa-solid fa-circle-info"
    },
    {
        title : "Contact",
        url : "/contact",
        cName : "nav-links",
        icon :  "fa-solid fa-address-book"
    },
    {
        title : "Signup",
        url : "/signup",
        cName : "nav-links-mobile",
    }
]